import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Grid, styled, Typography } from "@mui/material"

import i18n from "config/i18n"
import { useAppDispatch } from "redux/hooks"
import { closeDialog } from "redux/features/dialog/dialogSlice"
import { makeNps } from "redux/features/nps/npsThunk"
import Spinner from "components/ui/Spinner"
import Button from "components/ui/Button"
import Form from "components/Nps/Form"
import { NpsFormValues } from "types"

type Props = {
  paymentScheduleId: string
  onFailure: () => void
  onSuccess: () => void
}

const NetPromoterScore = ({
  paymentScheduleId,
  onSuccess,
  onFailure,
}: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [isSubmitting, setSubmitting] = useState(false)

  const handleSubmit = (values: NpsFormValues) => {
    setSubmitting(true)

    const { rating, payment_schedule_id } = values
    const locale = i18n.language

    dispatch(makeNps({ rating, payment_schedule_id, locale }))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        // TODO: show flash message with error and enable form
        onFailure()
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  const handleClick = () => {
    dispatch(closeDialog())
    navigate("/")
  }

  return (
    <Container
      container
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <Spinner open={isSubmitting} />
      <Title variant="h3">{t("features.nps.form.title")}</Title>
      <Form
        initialValues={{
          rating: 0,
          payment_schedule_id: paymentScheduleId,
        }}
        onSubmit={handleSubmit}
      />
      <Cancel onClick={handleClick}>{t("features.nps.form.cancel")}</Cancel>
    </Container>
  )
}

export default NetPromoterScore

const Container = styled(Grid)`
  margin: 0 auto 54px auto;
  max-width: 464px;
  text-align: center;
`
const Title = styled(Typography)`
  margin-bottom: 148px;
`
const Cancel = styled(Button)`
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.main};
  display: block;
  margin: 0 auto;
  text-align: center;
  width: 200px;
`
